import React from "react";

const SvgComponent = props => (
  <svg
    width={61}
    height={61}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{`courseware/2`}</title>
    <defs>
      <path
        d="M0 29.717c0 16.098 13.051 29.148 29.149 29.148s29.149-13.05 29.149-29.148c0-16.1-13.051-29.15-29.149-29.15S0 13.617 0 29.717"
        id="a"
      />
      <path
        d="M0 29.717c0 16.098 13.051 29.148 29.149 29.148s29.149-13.05 29.149-29.148c0-16.1-13.051-29.15-29.149-29.15S0 13.617 0 29.717z"
        id="c"
      />
      <path
        d="M0 29.717c0 16.098 13.051 29.148 29.149 29.148s29.149-13.05 29.149-29.148c0-16.1-13.051-29.15-29.149-29.15S0 13.617 0 29.717"
        id="e"
      />
      <path
        d="M0 29.717c0 16.098 13.051 29.148 29.149 29.148s29.149-13.05 29.149-29.148c0-16.1-13.051-29.15-29.149-29.15S0 13.617 0 29.717"
        id="g"
      />
      <path
        d="M0 29.717c0 16.098 13.051 29.148 29.149 29.148s29.149-13.05 29.149-29.148c0-16.1-13.051-29.15-29.149-29.15S0 13.617 0 29.717"
        id="i"
      />
      <path
        d="M0 29.717c0 16.098 13.051 29.148 29.149 29.148s29.149-13.05 29.149-29.148c0-16.1-13.051-29.15-29.149-29.15S0 13.617 0 29.717"
        id="k"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(1 .433)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          d="M109.733 95h-96.74a1.989 1.989 0 0 1-1.989-1.988V29.366h100.718v63.646c0 1.098-.89 1.988-1.99 1.988"
          fill="#EBEBEB"
          mask="url(#b)"
        />
      </g>
      <g transform="translate(1 .433)">
        <mask id="d" fill="#fff">
          <use xlinkHref="#c" />
        </mask>
        <path
          d="M111.722 33.749H11.005V21.14a3.489 3.489 0 0 1 3.488-3.49h93.74a3.489 3.489 0 0 1 3.489 3.49v12.608z"
          fill="#949494"
          mask="url(#d)"
        />
      </g>
      <g transform="translate(1 .433)">
        <mask id="f" fill="#fff">
          <use xlinkHref="#e" />
        </mask>
        <path
          d="M103.84 50.527H17.08a1.241 1.241 0 0 1-1.241-1.241v-10.6c0-.685.556-1.241 1.24-1.241h86.76a1.24 1.24 0 0 1 1.242 1.24v10.6a1.24 1.24 0 0 1-1.241 1.242"
          fill="#FFF"
          mask="url(#f)"
        />
      </g>
      <g transform="translate(1 .433)">
        <mask id="h" fill="#fff">
          <use xlinkHref="#g" />
        </mask>
        <path
          d="M24.408 25.646a3.767 3.767 0 1 1-7.533 0 3.767 3.767 0 0 1 7.533 0"
          fill="#75CFEC"
          mask="url(#h)"
        />
      </g>
      <g transform="translate(1 .433)">
        <mask id="j" fill="#fff">
          <use xlinkHref="#i" />
        </mask>
        <path
          d="M36.575 25.646a3.767 3.767 0 1 1-7.533 0 3.767 3.767 0 0 1 7.533 0"
          fill="#23C991"
          mask="url(#j)"
        />
      </g>
      <g transform="translate(1 .433)">
        <mask id="l" fill="#fff">
          <use xlinkHref="#k" />
        </mask>
        <path
          d="M48.743 25.646a3.767 3.767 0 1 1-7.531.001 3.767 3.767 0 0 1 7.531-.001"
          fill="#75CFEC"
          mask="url(#l)"
        />
      </g>
      <path
        d="M59.298 30.15c0 16.098-13.051 29.147-29.148 29.147C14.05 59.297 1 46.248 1 30.15S14.05 1 30.15 1c16.097 0 29.148 13.05 29.148 29.15z"
        stroke="#FEAD64"
        strokeWidth={2}
      />
    </g>
  </svg>
);

export default SvgComponent;
